import { Icon } from "components/Icon"

export function DownloadLinks() {
    return (
        <div className="download-links">
            <a
                href="https://zoom.us/download"
                target="_blank"
                rel="noopener noreferrer"
                className="download-links__link-with-margin"
            >
                <Icon role="button" type="zoom-icon" size={24} /> <span>Скачать Zoom</span>
            </a>
            <a href="https://www.skype.com/ru/get-skype" target="_blank" rel="noopener noreferrer">
                <Icon role="button" type="skype-icon" size={24} /> <span>Скачать Skype</span>
            </a>
        </div>
    )
}
